import React from 'react';
import PropTypes from 'prop-types';
import tw from 'twin.macro';
import Label from '~/src/atoms/Label/';
import StarIcon from '~/public/bb2assets/images/svgComponents/Star';

export const getRatingsCss = (value) => {
  const label = [];
  const star = [];
  switch (true) {
    case value < 2:
      label.push(tw`bg-rossoCorsa-50 text-rossoCorsa-700`);
      star.push(tw`text-rossoCorsa-700`);
      break;
    case value < 3 && value >= 2:
      label.push(tw`bg-sunglow-100 text-darkOrange-700`);
      star.push(tw`text-darkOrange-700`);
      break;
    case value >= 3:
      label.push(tw`bg-appleGreen-100 text-appleGreen-700`);
      star.push(tw`text-appleGreen-700`);
      break;
    default:
      break;
  }
  return { label, star };
};

const Badges = ({ value, starCss = '', labelCss = '', ...rest }) => {
  const { label, star } = getRatingsCss(value);

  labelCss = [labelCss, ...label];
  starCss = [starCss, ...star];

  return (
    <Label css={[tw`px-1 rounded-3xl flex justify-center items-center font-regular text-sm h-4`, labelCss]} {...rest}>
      <Label>{value}</Label>
      <StarIcon css={[tw`fill-current stroke-current ml-0.5 -mt-px`, starCss]} />
    </Label>
  );
};

Badges.propTypes = {
  value: PropTypes.any,
};

export default Badges;
